import React from 'react';
var FlechaAtras = function (_a) {
    var className = _a.className;
    return (React.createElement("svg", { className: className, width: "20", height: "20", viewBox: "0 0 20 20", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { d: "M7.97496 4.94165L2.91663 9.99998L7.97496 15.0583", stroke: "var(--icon-primary-dark)", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" }),
        React.createElement("path", { d: "M17.0833 10H3.05835", stroke: "var(--icon-primary-dark)", strokeWidth: "1.5", strokeMiterlimit: "10", strokeLinecap: "round", strokeLinejoin: "round" })));
};
FlechaAtras.defaultProps = {
    className: '',
};
export default FlechaAtras;
